// Certificate URL Builder
const buildCertificateUrl = (certificateId) => {
  return `https://sereininc.com/certificate/${certificateId}`;
};

const firestoreTimestampToDate = (timestamp) => {
  if (!timestamp) return null;

  if (timestamp instanceof Date) return timestamp;

  if (typeof timestamp.toDate === "function") return timestamp.toDate();

  const seconds = timestamp._seconds ?? timestamp.seconds;
  if (seconds !== undefined) return new Date(seconds * 1000);

  if (typeof timestamp === "string" || typeof timestamp === "number") {
    return new Date(timestamp);
  }

  return null;
};

// LinkedIn Add to Profile URL Builder
const buildLinkedInAddToProfileUrl = ({
  name,
  issuedOn,
  expiry,
  organizationId = 10011793,
  certId,
}) => {
  const issuedDate = firestoreTimestampToDate(issuedOn);
  const expiryDate = firestoreTimestampToDate(expiry);

  const params = new URLSearchParams({
    startTask: "CERTIFICATION_NAME",
    name: name || "",
    organizationId: organizationId,
    certUrl: buildCertificateUrl(certId) || "",
    certId: certId || "",
  });

  // Only append date params if valid
  if (issuedDate) {
    params.set("issueYear", issuedDate.getFullYear());
    params.set("issueMonth", issuedDate.getMonth() + 1);
  }
  if (expiryDate) {
    params.set("expirationYear", expiryDate.getFullYear());
    params.set("expirationMonth", expiryDate.getMonth() + 1);
  }

  console.log(
    "params",
    `https://www.linkedin.com/profile/add?${params.toString()}`,
  );
  return `https://www.linkedin.com/profile/add?${params.toString()}`;
};

export { buildCertificateUrl, buildLinkedInAddToProfileUrl };
